import { MetadataIcon } from '#app/components/icons'

export default {
	name: 'Bulk',
	slug: 'bulk',
	description: 'Create many attestations with a single signature',
	version: '1.0.0',
	icon: <MetadataIcon />,
	fields: [
		{
			name: 'Bulk CID',
			slug: 'bulkCID',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'Bulk CID',
		},
	],
	info: '',
}
